import DataObject from '../../../common/model/DataObject';

import DataChannelList from './DataChannelList';

export default class DataConnector extends DataObject {
  getPropertyNames() {
    return [
      'identifier',
      'outputDataChannels'
    ];
  }

  getChildClassTypes() {
    return {
      outputDataChannels: DataChannelList
    };
  }
}